export const JOIN_SURVEY_EVENTS_ROOM = 'JOIN_SURVEY_EVENTS_ROOM';
export const ON_SURVEY_EVENT = 'ON_SURVEY_EVENT';
export const ON_SURVEY_TRACKING_EVENT = 'ON_SURVEY_TRACKING_EVENT';
export const ON_SURVEY_ANSWER_EVENT = 'ON_SURVEY_ANSWER_EVENT';
